import React from 'react';

/**
 * Spirify Logo Component
 * Iconic, memorable logo representing spiritual learning and unity
 * Design: Lotus/mandala flower symbolizing enlightenment, growth, and unity of religions
 */

export const LogoIcon = ({ className = "w-10 h-10" }) => (
  <svg
    viewBox="0 0 100 100"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#6366f1', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#8b5cf6', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#d97706', stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="logoGradientAlt" x1="100%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#f59e0b', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#8b5cf6', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    
    {/* Outer petals - representing different religions coming together */}
    <g className="outer-petals">
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
        <ellipse
          key={i}
          cx="50"
          cy="50"
          rx="12"
          ry="30"
          fill="url(#logoGradient)"
          opacity="0.8"
          transform={`rotate(${angle} 50 50)`}
        />
      ))}
    </g>
    
    {/* Inner circle - unity and enlightenment */}
    <circle
      cx="50"
      cy="50"
      r="18"
      fill="url(#logoGradientAlt)"
    />
    
    {/* Center light - knowledge and wisdom */}
    <circle
      cx="50"
      cy="50"
      r="8"
      fill="white"
      opacity="0.95"
    />
    
    {/* Sparkle effect */}
    <circle cx="50" cy="50" r="3" fill="#fbbf24" />
  </svg>
);

export const LogoFull = ({ className = "", iconClassName = "w-10 h-10", textClassName = "" }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <LogoIcon className={iconClassName} />
    <div className={`font-bold text-2xl ${textClassName}`}>
      <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-amber-500 bg-clip-text text-transparent">
        Spirify
      </span>
    </div>
  </div>
);

export const LogoIconOnly = ({ size = 40 }) => (
  <LogoIcon className={`w-${size} h-${size}`} />
);

export default LogoFull;
